import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.error.cause.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useContext, useEffect, cloneElement } from 'react';
import PropTypes from 'prop-types';
import { CarouselProvider, Slide, CarouselContext, Slider } from 'pure-react-carousel';
import { layoutToFlexWidths } from './layoutToFlexWidths';
import { CarouselWrapper, RelativeFlex } from './Carousel.styles';
import { Flex, Relative, Box, SlideBox } from 'pcln-design-system';
import { Dots } from './Dots';
import { ArrowButton } from './ArrowButton';
import { getSlideKey, getVisibleSlidesArray, useResponsiveVisibleSlides, getMobileVisibleSlides } from './helpers';
import { RenderInView } from './RenderInView';
import { CAROUSEL_BREAKPOINT_1, ARROW_MARGIN, ARROW_JUSTIFY_CONTENT } from './constants';
var ChangeDetector = function ChangeDetector(_ref) {
  var onSlideChange = _ref.onSlideChange;
  var carouselContext = useContext(CarouselContext);
  // eslint-disable-next-line no-unused-vars
  var _useState = useState(carouselContext.state.currentSlide),
    _useState2 = _slicedToArray(_useState, 2),
    _currentSlide = _useState2[0],
    setCurrentSlide = _useState2[1];
  useEffect(function () {
    function onChange() {
      setCurrentSlide(carouselContext.state.currentSlide);
      if (typeof onSlideChange === 'function') {
        onSlideChange(carouselContext.state.currentSlide);
      }
    }
    carouselContext.subscribe(onChange);
    return function () {
      return carouselContext.unsubscribe(onChange);
    };
  }, [carouselContext, onSlideChange]);
  return null;
};
ChangeDetector.propTypes = {
  onSlideChange: PropTypes.func
};
export var Carousel = function Carousel(_ref2) {
  var children = _ref2.children,
    _ref2$showDots = _ref2.showDots,
    showDots = _ref2$showDots === void 0 ? false : _ref2$showDots,
    layout = _ref2.layout,
    _ref2$infinite = _ref2.infinite,
    infinite = _ref2$infinite === void 0 ? false : _ref2$infinite,
    naturalSlideHeight = _ref2.naturalSlideHeight,
    _ref2$step = _ref2.step,
    step = _ref2$step === void 0 ? 1 : _ref2$step,
    _ref2$isIntrinsicHeig = _ref2.isIntrinsicHeight,
    isIntrinsicHeight = _ref2$isIntrinsicHeig === void 0 ? true : _ref2$isIntrinsicHeig,
    _ref2$lockOnWindowScr = _ref2.lockOnWindowScroll,
    lockOnWindowScroll = _ref2$lockOnWindowScr === void 0 ? true : _ref2$lockOnWindowScr,
    _ref2$orientation = _ref2.orientation,
    orientation = _ref2$orientation === void 0 ? 'horizontal' : _ref2$orientation,
    _ref2$naturalSlideWid = _ref2.naturalSlideWidth,
    naturalSlideWidth = _ref2$naturalSlideWid === void 0 ? 100 : _ref2$naturalSlideWid,
    _ref2$visibleSlides = _ref2.visibleSlides,
    visibleSlides = _ref2$visibleSlides === void 0 ? 1 : _ref2$visibleSlides,
    _ref2$arrowsPosition = _ref2.arrowsPosition,
    arrowsPosition = _ref2$arrowsPosition === void 0 ? 'side' : _ref2$arrowsPosition,
    _ref2$slideSpacing = _ref2.slideSpacing,
    slideSpacing = _ref2$slideSpacing === void 0 ? 2 : _ref2$slideSpacing,
    onSlideChange = _ref2.onSlideChange,
    _ref2$sideButtonMargi = _ref2.sideButtonMargin,
    sideButtonMargin = _ref2$sideButtonMargi === void 0 ? '-30px' : _ref2$sideButtonMargi,
    sidePositionArrowButton = _ref2.sidePositionArrowButton,
    _ref2$stretchSlideHei = _ref2.stretchSlideHeight,
    stretchSlideHeight = _ref2$stretchSlideHei === void 0 ? true : _ref2$stretchSlideHei,
    _ref2$currentSlide = _ref2.currentSlide,
    currentSlide = _ref2$currentSlide === void 0 ? 0 : _ref2$currentSlide,
    _ref2$onSlideClick = _ref2.onSlideClick,
    onSlideClick = _ref2$onSlideClick === void 0 ? function () {} : _ref2$onSlideClick,
    _ref2$onSlideKeyDown = _ref2.onSlideKeyDown,
    onSlideKeyDown = _ref2$onSlideKeyDown === void 0 ? function () {} : _ref2$onSlideKeyDown,
    mobileVisibleSlides = _ref2.mobileVisibleSlides,
    displayArrowsMobile = _ref2.displayArrowsMobile,
    _ref2$buttonSize = _ref2.buttonSize,
    buttonSize = _ref2$buttonSize === void 0 ? '60px' : _ref2$buttonSize,
    _ref2$showArrowsOnHov = _ref2.showArrowsOnHover,
    showArrowsOnHover = _ref2$showArrowsOnHov === void 0 ? false : _ref2$showArrowsOnHov,
    nodeBesideArrowsLeft = _ref2.nodeBesideArrowsLeft,
    nodeBesideArrowsRight = _ref2.nodeBesideArrowsRight,
    _ref2$arrowsAlignment = _ref2.arrowsAlignment,
    arrowsAlignment = _ref2$arrowsAlignment === void 0 ? 'center' : _ref2$arrowsAlignment,
    _ref2$overflowAllowan = _ref2.overflowAllowancePxX,
    overflowAllowancePxX = _ref2$overflowAllowan === void 0 ? 0 : _ref2$overflowAllowan,
    _ref2$overflowAllowan2 = _ref2.overflowAllowancePxY,
    overflowAllowancePxY = _ref2$overflowAllowan2 === void 0 ? 0 : _ref2$overflowAllowan2,
    _ref2$overflowAllowan3 = _ref2.overflowAllowancePxTop,
    overflowAllowancePxTop = _ref2$overflowAllowan3 === void 0 ? 0 : _ref2$overflowAllowan3,
    maxHeight = _ref2.maxHeight,
    arrowButtonZIndex = _ref2.arrowButtonZIndex;
  var widths = layoutToFlexWidths(layout, children.length);
  var layoutSize = layout === null || layout === void 0 ? void 0 : layout.split('-').length;
  var visibleSlidesArray = getVisibleSlidesArray(visibleSlides);
  var _useResponsiveVisible = useResponsiveVisibleSlides(visibleSlidesArray),
    responsiveVisibleSlides = _useResponsiveVisible.responsiveVisibleSlides,
    browserWidth = _useResponsiveVisible.browserWidth;
  var overflowAdjust = overflowAllowancePxTop ? (overflowAllowancePxTop + overflowAllowancePxY) / 2 : overflowAllowancePxY;
  if (!displayArrowsMobile && browserWidth < CAROUSEL_BREAKPOINT_1) {
    return /*#__PURE__*/React.createElement(SlideBox, {
      slideSpacing: slideSpacing,
      stretchHeight: stretchSlideHeight,
      layout: layout,
      onSlideChange: onSlideChange,
      visibleSlides: mobileVisibleSlides || getMobileVisibleSlides(visibleSlides),
      currentSlideOverride: currentSlide,
      overflowAllowancePxX: overflowAllowancePxX,
      overflowAllowancePxY: overflowAllowancePxY,
      overflowAllowancePxTop: overflowAllowancePxTop
    }, React.Children.map(children, function (item) {
      return item;
    }));
  }
  return /*#__PURE__*/React.createElement(CarouselWrapper, {
    overflowAllowancePxX: overflowAllowancePxX,
    overflowAllowancePxY: overflowAllowancePxY,
    overflowAllowancePxTop: overflowAllowancePxTop,
    maxHeight: maxHeight
  }, /*#__PURE__*/React.createElement(CarouselProvider, {
    naturalSlideWidth: naturalSlideWidth,
    naturalSlideHeight: naturalSlideHeight,
    totalSlides: children.length,
    visibleSlides: layoutSize || responsiveVisibleSlides,
    dragEnabled: children.length > (layoutSize || responsiveVisibleSlides),
    isIntrinsicHeight: isIntrinsicHeight,
    step: layoutSize || step,
    dragStep: layoutSize || step,
    lockOnWindowScroll: lockOnWindowScroll,
    orientation: orientation,
    infinite: infinite,
    currentSlide: currentSlide
  }, /*#__PURE__*/React.createElement(ChangeDetector, {
    onSlideChange: onSlideChange
  }), arrowsPosition === 'top' ? /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "flex-end",
    alignItems: "center",
    mb: 2,
    mr: slideSpacing
  }, nodeBesideArrowsLeft ? /*#__PURE__*/React.createElement(Box, {
    ml: 2,
    mr: "auto"
  }, nodeBesideArrowsLeft) : null, /*#__PURE__*/React.createElement(ArrowButton, {
    type: "prev",
    position: "top",
    setPosition: arrowsPosition,
    buttonSize: buttonSize
  }), /*#__PURE__*/React.createElement(ArrowButton, {
    type: "next",
    position: "top",
    ml: 3,
    setPosition: arrowsPosition,
    buttonSize: buttonSize
  })) : null, /*#__PURE__*/React.createElement(Relative, null, sidePositionArrowButton ? ( /*#__PURE__*/cloneElement(sidePositionArrowButton, {
    ml: sideButtonMargin,
    pl: slideSpacing,
    type: 'prev',
    position: 'side',
    setPosition: arrowsPosition,
    showArrowsOnHover: showArrowsOnHover
  })) : /*#__PURE__*/React.createElement(ArrowButton, {
    overflowAdjust: overflowAdjust,
    ml: sideButtonMargin,
    pl: slideSpacing,
    type: "prev",
    position: "side",
    setPosition: arrowsPosition,
    buttonSize: buttonSize,
    showArrowsOnHover: showArrowsOnHover
  }), /*#__PURE__*/React.createElement(Slider, null, React.Children.map(children, function (item, index) {
    return (
      /*#__PURE__*/
      // We only need to manually set width of Slide if using the `layout` prop
      React.createElement(Slide, {
        index: index,
        key: getSlideKey(item),
        style: widths[index] && {
          width: widths[index]
        },
        "data-testid": "slide-".concat(index),
        onClick: function onClick(e) {
          onSlideClick(index, e);
        },
        onKeyDown: function onKeyDown(e) {
          onSlideKeyDown(index, e);
        }
      }, /*#__PURE__*/React.createElement(RenderInView, {
        index: index,
        onSlideChange: onSlideChange,
        displayArrowsMobile: displayArrowsMobile
      }, /*#__PURE__*/React.createElement(Box, {
        p: slideSpacing,
        height: "100%"
      }, !layout && stretchSlideHeight ? /*#__PURE__*/React.cloneElement(item, {
        style: {
          'min-height': '100%'
        }
      }) : item)))
    );
  })), sidePositionArrowButton ? ( /*#__PURE__*/cloneElement(sidePositionArrowButton, {
    mr: sideButtonMargin,
    pr: slideSpacing,
    type: 'next',
    position: 'side',
    setPosition: arrowsPosition,
    showArrowsOnHover: showArrowsOnHover
  })) : /*#__PURE__*/React.createElement(ArrowButton, {
    overflowAdjust: overflowAdjust,
    mr: sideButtonMargin,
    pr: slideSpacing,
    type: "next",
    position: "side",
    setPosition: arrowsPosition,
    buttonSize: buttonSize,
    showArrowsOnHover: showArrowsOnHover
  })), arrowsPosition === 'bottom' || showDots ? /*#__PURE__*/React.createElement(RelativeFlex, {
    alignItems: "center",
    justifyContent: ARROW_JUSTIFY_CONTENT[arrowsAlignment],
    pt: 2,
    zIndex: arrowButtonZIndex
  }, nodeBesideArrowsLeft && arrowsAlignment === 'right' ? /*#__PURE__*/React.createElement(Box, {
    ml: 2,
    mr: "auto"
  }, nodeBesideArrowsLeft) : null, /*#__PURE__*/React.createElement(ArrowButton, {
    mr: ARROW_MARGIN[arrowsAlignment],
    type: "prev",
    position: "bottom",
    setPosition: arrowsPosition
  }), showDots && /*#__PURE__*/React.createElement(Dots, null), /*#__PURE__*/React.createElement(ArrowButton, {
    ml: ARROW_MARGIN[arrowsAlignment],
    type: "next",
    position: "bottom",
    setPosition: arrowsPosition
  }), nodeBesideArrowsRight && arrowsAlignment === 'left' ? /*#__PURE__*/React.createElement(Box, {
    mr: 2,
    ml: "auto"
  }, nodeBesideArrowsRight) : null) : null));
};
Carousel.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
  /** Number of slides to display at once. If using `layout`,
   * this will be overridden by the number of items in the layout.
   * Can also be sent as array to set responsive sizes:
   * [below 768px, below 1024px, above 1020px]
   * E.g. `layout={'25-50-25'}` will result in 3 slides shown per page.
   * Note: decimal values are accepted too E.g. `[1,2.5,3.2]`*/
  visibleSlides: PropTypes.any,
  /** Show clickable navigation dots */
  showDots: PropTypes.bool,
  /** Percent width for each of the first N slides to use as a layout. Remaining slides will be divided
   * into pages with the same number of items as the "layout" page. Not compatible with vertical orientation. */
  layout: PropTypes.oneOf(['25-25-25-25', '33-33-33', '50-50', '40-60', '60-40', '25-75', '75-25']),
  /** When set to true, scrolling of the carousel slides are disabled while the browser window is scrolling */
  lockOnWindowScroll: PropTypes.bool,
  /** The natural height of each <Slide /> component */
  naturalSlideHeight: PropTypes.number,
  /** The natural width of each <Slide /> component */
  naturalSlideWidth: PropTypes.number,
  /** Possible values are "horizontal" and "vertical". Lets you have a horizontal or vertical carousel.
   * Not compatible with `layout`. Use vertical at own risk */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  /** The number of slides to move when pressing the <ButtonBack /> and <ButtonNext /> buttons.
   * When using `layout`, this will be overridden with the number of items in the layout value. */
  step: PropTypes.number,
  /** Should the carousel continue or stop at the beginning or end of the slides */
  infinite: PropTypes.bool,
  /** Disables the enforced height ratio, and instead uses the intrinsic height of the slides.
   * This option can only be active in horizontalorientation, it will throw an error in vertical orientation. */
  isIntrinsicHeight: PropTypes.bool,
  /** Positioning for the navigation arrow buttons */
  arrowsPosition: PropTypes.oneOf(['side', 'top', 'bottom', 'hide']),
  /** Padding around the slides */
  slideSpacing: PropTypes.number,
  /** Custom arrow button margin for side position/horizontal orientation */
  sideButtonMargin: PropTypes.string,
  /** Called each time the current slide changes, passed the new currentSlide (zero-indexed) */
  onSlideChange: PropTypes.func,
  /** Custom styled arrow button component */
  sidePositionArrowButton: PropTypes.element,
  /** Set height of slides based on tallest slide */
  stretchSlideHeight: PropTypes.bool,
  /** Set the initial visible slide (starts with 0) */
  currentSlide: PropTypes.number,
  /** Custom onClick event handler for each Slide child */
  onSlideClick: PropTypes.func,
  /** Custom onKeyDown event handler for each Slide child */
  onSlideKeyDown: PropTypes.func,
  /** Allows extra breakpoints for mobile. Should eventually combine with VisibleSlides */
  mobileVisibleSlides: PropTypes.array,
  /** Use the desktop carousel for mobile */
  displayArrowsMobile: PropTypes.bool,
  /** Set the height and width of the forward and back buttons to this value, e.g. "30px" */
  buttonSize: PropTypes.string,
  /** When arrow position is side, hide arrows and shows when hovers on carousel */
  showArrowsOnHover: PropTypes.bool,
  /** Node that will display to the left of the arrows (available if arrows are top, bottom-right) */
  nodeBesideArrowsLeft: PropTypes.node,
  /** Node that will display to the left of the arrows (availalbe if arrows are bottom-left) */
  nodeBesideArrowsRight: PropTypes.node,
  /** String "left" or "right" or "center" (only available if arrowsPosition is set to "bottom") */
  arrowsAlignment: PropTypes.oneOf(['left', 'right', 'center']),
  /** Number of px to allow overflow on top and bottom of Carousel to display things like shadows */
  overflowAllowancePxY: PropTypes.number,
  /** Number of px to allow overflow on left and right to display things like shadows */
  overflowAllowancePxX: PropTypes.number,
  /** Number of px to allow oveflow on top (will override the overflowAllowancePxY value for top) */
  overflowAllowancePxTop: PropTypes.number,
  /** Number of px to set maxHeight to counteract large overflow values*/
  maxHeight: PropTypes.number,
  /** z-index for arrow buttons*/
  arrowButtonZIndex: PropTypes.number
};